import {VALIDATION_STEPS, PITCH_VALIDATION_STEPS} from './validationSteps';
import {DISCLOSURE_VALIDATION_STEPS} from './disclosureValidationSteps';

export const isDisclosureProductType = (productTypeValue) => (
    productTypeValue === 'disclosure' || productTypeValue === 'ndp1_disclosure'
);

export const isPitchProductType = (productTypeValue) => productTypeValue === 'pitch';

export const getValidationStepsForProductType = (productTypeValue) => {
    if (isDisclosureProductType(productTypeValue)) return DISCLOSURE_VALIDATION_STEPS;
    if (isPitchProductType(productTypeValue)) return PITCH_VALIDATION_STEPS;
    return VALIDATION_STEPS;
};

export const isCreateIcrStep = (step) => step?.id === 'create_icr' || step?.id === 'create_rfi';
